(() => {
  const init = () => {
    let opener = null, title = '', kind = 'video', current = null, pending = false;
    const inerted = new Set();
    const release = () => { inerted.forEach(el => {el.inert=false;}); inerted.clear(); };
    const isolate = popup => {
      let current = popup;
      while (current.parentElement) {
        for (const el of current.parentElement.children) {
          if(el!==current && !el.inert && !el.matches('script,style,link')) {el.inert=true;inerted.add(el);}
        }
        current=current.parentElement;
        if(current===document.body)break;
      }
    };
    document.addEventListener('click', event => {
      const trigger=event.target.closest?.('[data-lb-media-title]');
      if(trigger){opener=trigger;title=trigger.dataset.lbMediaTitle;kind=trigger.dataset.lbMediaKind || 'video';}
      else if(event.target.closest?.('[data-fancybox]')) { title=''; }
    },true);
    const sync=()=>{
      pending=false;
      const popup=document.querySelector('.fancybox-is-open');
      if(!popup && current){
        release(); current=null; title='';
        if(opener?.isConnected)opener.focus({preventScroll:true});
      }
      if(popup && title){
        if(current!==popup){
          release();current=popup;
          popup.setAttribute('aria-label',(kind==='image'?'Image: ':'Video: ')+title);
          popup.setAttribute('aria-modal','true');
          popup.setAttribute('data-lb-media-dialog','');
          isolate(popup);
          requestAnimationFrame(()=>popup.querySelector('[data-fancybox-close]')?.focus({preventScroll:true}));
        }
        popup.querySelectorAll('video').forEach(video=>{
          if(video.getAttribute('aria-label')!==title)video.setAttribute('aria-label',title);
          if(!video.controls)video.controls=true;
        });
        popup.querySelectorAll('iframe').forEach(frame=>{
          if(frame.title!==title)frame.title=title;
        });
      }
      document.querySelectorAll('.productView .slick-cloned').forEach(el=>{
        if(el.hasAttribute('id')&&!el.id)el.removeAttribute('id');
      });
      document.querySelectorAll('.productView img.zoomImg[alt=""][role="presentation"]').forEach(el=>el.removeAttribute('role'));
    };
    const schedule=()=>{if(!pending){pending=true;requestAnimationFrame(sync);}};
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','id','role']});
    sync();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();